import axios from 'axios';

const inst = axios.create({
  baseURL: 'https://sugarnanny-api.herokuapp.com',
});

export default inst;



// WEBPACK FOOTER //
// ./src/api/index.js